// extracted by mini-css-extract-plugin
module.exports = {"link":"DownloadLink_link__MMwgF","icon":"DownloadLink_icon__ZeZeE"};